import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/AuthContext";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import MembersPortal from "@/pages/MembersPortal";
import AdminDashboard from "@/pages/AdminDashboard";
import TableTalk from "@/pages/TableTalk";
import "@/styles/typography.css";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/members" element={<MembersPortal />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/tabletalk" element={<TableTalk />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
